export default "__VITE_ASSET__D5A9ovf$__"